export const Emirateslist = [
  { value: 'Abu Dhabi', label: 'Abu Dhabi' },
  { value: 'Dubai', label: 'Dubai' },
  { value: 'Sharjah', label: 'Sharjah' },
  { value: 'Ajman', label: 'Ajman' },
  { value: 'Umm Al Quwain', label: 'Umm Al Quwain' },
  { value: 'Ras Al Khaimah', label: 'Ras Al Khaimah' },
  { value: 'Fujairah', label: 'Fujairah' },
];

export const NumberofRooms = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: 'More than 4', label: 'More than 4' },
];

export const TypeofRoom = [
  { value: 'Bedroom', label: 'Bedroom' },
  { value: 'Bathroom', label: 'Bathroom' },
  { value: "Kid's room", label: "Kid's room" },
  { value: 'Home office', label: 'Home office' },
  { value: 'Majlis', label: 'Majlis' },
];

export const RoomSize = [
  { value: 'Large', label: 'Large' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Small', label: 'Small' },
];

export const ResidenceType = [
  { value: 'Villa', label: 'Villa' },
  { value: 'Townhouse', label: 'Townhouse' },
  { value: 'Apartment', label: 'Apartment' },
];

export const RoomQuantities = [1, 2, 3, 4, 5].map((n) => ({ value: n, label: String(n) }));

export const ServiceMode = [
  { value: 'In Store', label: 'In Store' },
  { value: 'Remote', label: 'Remote' },
];

export const PreferredLanguageList = [
  { value: 'English', label: 'English' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Russian', label: 'Russian' },
];
